<template>
  <Header></Header>
  <router-view />
  <Footer></Footer>
</template>

<script>
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer
  },
  created() {
    this.getCategory();
  },
  methods: {
    getCategory() {
      this.$api.get({
        url: "article/category",
        success: (res) => {
          let data = [];
          this.$store.commit("setCategoryList", res.data);
          res.data.forEach((element) => {
            const ads = element;
            if (ads.id == 6) {
              ads.child = [];
              ads.child.push({ id: 6, name: "专利库" });
            }
            data.push(ads);
          });
          this.$store.commit("setTabList", data);
        }
      });
    }
  }
};
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
  min-width: 1000px;
  max-width: 2000px;
  margin: 0 auto;
}
</style>
